import { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { LinearInfoModal } from "../../components/cai-info-modal/LinearInfoModal";
import SinistroCardLinear from "../../components/cards/SinistroCardLinear";
import LinearFooterCmp from "../../components/footer/LinearFooter";
import { RealtimeModal } from "../../components/modal/RealtimeModal";
import { LNextButton, SecondChoiseButton, } from "../../components/styled/Button.style";
import { LTitleIconSection, Section } from "../../components/styled/Containers.style";
import { Vspace } from '../../components/styled/Separators.style';
import { LPageTitle, LSimpleText } from "../../components/styled/Text.style";
import { LINEAR_BASE_ROUTE, LINEAR_PATHS } from "../../routes/linearRouteConstants";
import { selectCommunicationData } from "../../store";
import { useAppSelector } from "../../store/hooks";
import { EventCommType, EventValueEnum } from "../../types/communication/communicationDataType";
import { composeUrl } from "../../utils/utils";
import LinearPhone from './../../assets/img/linearPhone.svg';
import PageContainerCmp from "./../PageContainerCmp";
import { LinearHelpRequestText } from "./LinearHelpRequestText";

const RequireDocumentsPageLinear = () => {
    const [openHelpModal, setOpenHelpModal] = useState(false)
    const communicationData = useAppSelector(selectCommunicationData)
    const navigate = useNavigate();
    const [searchParams, setSearchParams] = useSearchParams();
    const { communication } = communicationData
    const { token, events } = communication;

    useEffect(() => {
        const docParam = searchParams.get('doc');
        if (docParam === 'true') {
            // Rimuovi il parametro 'doc' dalla query string
            const newSearchParams = new URLSearchParams(searchParams);
            newSearchParams.delete('doc');
            setSearchParams(newSearchParams);
            
            const nextPath = composeUrl(token, LINEAR_PATHS.REQUIRE_DOCUMENTS_PAGE, LINEAR_BASE_ROUTE);
            navigate(nextPath);
        }
    }, [searchParams, token, navigate, setSearchParams]);

    const goToNextStepHandler = () => {
        let nextPath = composeUrl(token, LINEAR_PATHS.REQUIRE_DENUNCIA_PAGE, LINEAR_BASE_ROUTE)
        //const urlParams = new URLSearchParams(window?.location?.search || '')
        //const isRequiringDocuments = urlParams.get('docs') === 'true'
        const isRequiringDocuments = communication?.events?.find((ev: EventCommType) => ev?.value === EventValueEnum.USER_SIGNATURE_OUTCOME_CALLED)
        if (isRequiringDocuments) {
            nextPath = composeUrl(token, LINEAR_PATHS.OPTIONAL_DOCUMENTS_PAGE, LINEAR_BASE_ROUTE)
        }
        navigate(nextPath)
    }

    const goToHelp = () => {
        setOpenHelpModal(true)
    }

    let isFirstLoading = true
    if (events?.find(el => el.value === EventValueEnum.LINEAR_SEND_DOCUMENTS)) {
        isFirstLoading = false
    }



    return (
        <>

            <RealtimeModal
                companyName={communication?.companyName}
                modalOpened={openHelpModal}
                hTitle="CONTATTACI"
                hCloseButton={true}
                /* istanbul ignore next */
                onCloseHandler={() => setOpenHelpModal(false)}>
                <LinearInfoModal
                    close={() => setOpenHelpModal(false)}
                    additionalImage={LinearPhone}
                    text={<LinearHelpRequestText />}
                />
            </RealtimeModal>

            <PageContainerCmp
                nextStepHandler={goToNextStepHandler}
                routePath={LINEAR_PATHS.REQUIRE_DOCUMENTS_PAGE}
                removeNextBtn
            >

                <Section linear={true}>

                    <>
                        <SinistroCardLinear />
                        <Vspace qty={2}></Vspace>
                    </>

                    <LTitleIconSection>
                        <LPageTitle>{isFirstLoading ? "RACCOLTA DOCUMENTI" : "INTEGRA DOCUMENTI"}</LPageTitle>
                    </LTitleIconSection>

                    {!isFirstLoading && <>
                        <Vspace qty={2}></Vspace>
                        <LSimpleText className="left">Hai già caricato alcuni documenti, per <strong style={{ color: "#575757" }}>completare</strong> la <strong style={{ color: "#575757" }}>denuncia</strong> del sinistro puoi <strong style={{ color: "#575757" }}>caricare altre foto/immagini o .pdf dei documenti</strong> a supporto della tua richiesta.</LSimpleText>
                        <Vspace qty={2}></Vspace>
                        <LSimpleText className="left"><strong style={{ color: "#575757" }}>Puoi allegare i documenti</strong> anche separatamente non appena li hai disponibili.</LSimpleText>
                        <LSimpleText className="left">Ricorda che:</LSimpleText>
                        <Vspace qty={1}></Vspace>
                        <LSimpleText className="left">
                            <ul style={{ margin: "0 3px 0 20px" }}>
                                <li>puoi <strong style={{ color: "#575757" }}>completare la procedura entro 15 giorni dalla data di ricezione del link via SMS</strong></li>
                                <Vspace qty={1}></Vspace>
                                <li><strong style={{ color: "#575757" }}>Cliccando su "PROCEDI" i documenti caricati non saranno più modificabili. </strong></li>
                            </ul>
                        </LSimpleText>
                        <Vspace qty={2}></Vspace>
                    </>}

                    {isFirstLoading && <>
                        <Vspace qty={2}></Vspace>
                        <LSimpleText className="left">Per completare le informazioni necessarie alla lavorazione del tuo sinistro è necessario caricare foto/immagini o pdf di alcuni documenti.</LSimpleText>
                        <Vspace qty={2}></Vspace>
                        <LSimpleText className="left">Puoi allegare i documenti anche separatamente non appena li hai disponibili.</LSimpleText>
                        <LSimpleText className="left">Ricorda che:</LSimpleText>
                        <Vspace qty={1}></Vspace>
                        <LSimpleText className="left">
                            <ul style={{ margin: "0 3px 0 20px" }}>
                                <li>puoi <strong style={{ color: "#575757" }}>completare la procedura entro 15 giorni dalla data di ricezione del link via SMS</strong></li>
                                <Vspace qty={1}></Vspace>
                                <li><strong style={{ color: "#575757" }}>i documenti inviati non saranno più modificabili</strong></li>
                            </ul>
                        </LSimpleText>
                    </>}

                </Section>

                <Vspace qty={3}></Vspace>

                <Section linear={true}>
                    <LNextButton onClick={goToNextStepHandler}>PROCEDI</LNextButton>
                    <Vspace qty={2}></Vspace>
                    <SecondChoiseButton linear={true} onClick={goToHelp}>Hai bisogno di aiuto?</SecondChoiseButton>
                </Section>

                <LinearFooterCmp />

            </PageContainerCmp>
        </>

    )
}

export default RequireDocumentsPageLinear